import StylePopup from './StylePopup';

export default StylePopup;